import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { detail, questionnaireSave } from '../request';
import singleLineMultilineModel from '../components/singleLineMultilineModel.vue'; //单行文本and多行文本
import signModel from '../components/signModel.vue'; //签名组件
import paragraphModel from '../components/paragraphModel.vue'; //段落
import enclosureModel from '../components/enclosureModel.vue'; //附件
import paymentEstimateModel from '../components/paymentEstimateModel.vue'; //赔付金额and估损金额
import tableControl from '../components/tableControl.vue';
import multipleChoice from '../components/multipleChoice.vue';
import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
import dateControl from '../components/dateControl.vue';
import dropDownSelect from '../components/dropDownSelect.vue';
import singleChoice from '../components/singleChoice.vue';
import previewFileModel from '@/views/components/previewFile/previewFileModel.vue';
import { checkEmail } from '@/utils/validate';
import { mapState } from 'vuex';
import formItemMixin from '@/mixins/formItemMixin';
import moment from 'moment';
export default {
  components: {
    tableControl,
    signModel,
    singleChoice,
    multipleChoice,
    emailSendModel,
    dateControl,
    paragraphModel,
    enclosureModel,
    dropDownSelect,
    previewFileModel,
    singleLineMultilineModel,
    paymentEstimateModel
  },
  mixins: [formItemMixin],
  data() {
    return {
      // 下拉结束----------------
      editableArea: [],
      actionButton: [],
      formData: {},
      // 表单数据对象
      formItems: [],
      //获取的数据
      showSendEmail: false,
      notifyData: null,
      showPreviewFile: false,
      previewFileList: [],
      associationInfo: {},
      showControl: {},
      loading: false
    };
  },
  created() {
    this.$store.dispatch('quiretionnaire/getResource');
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    })
  },
  mounted() {
    this.getdetail();
  },
  methods: {
    // 获取国家接口数据
    getdetail() {
      let Query = {
        auditFlowId: this.$route.params.id
      };
      detail(Query).then(res => {
        this.editableArea = res.editableArea;
        this.actionButton = res.actionButton;
        // 对接口返回的数据进行处理
        res.editableArea && Array.isArray(res.editableArea) && res.editableArea.forEach(item => {
          item.form.forEach(control => {
            var _controlItem$associat;
            if (control.controlType === 'control') {
              var _control$control;
              control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
              if (control.control.partsType === 'multipleChoice') {
                this.$set(this.formData, control.control.mark, []);
              }
            } else {
              control.mark = control.mark.replace('d.', 'd_');
              let groupControl = control.control;
              groupControl.forEach(item => {
                item.mark = item.mark.replace('d.', 'd_');
              });
            }
            //设置控件显隐 以及处理关联关系
            let mark = control.controlType === 'control' ? control.control.mark : control.mark;
            let controlItem = control.controlType === 'control' ? control.control : control;
            if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
              let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
              let value = controlItem.association.association[0];
              value.targetKey = mark;
              if (Array.isArray(this.associationInfo[key])) {
                this.associationInfo[key].push(value);
              } else {
                this.associationInfo[key] = [value];
              }
              this.$set(this.showControl, mark, false);
            } else {
              this.$set(this.showControl, mark, true);
            }
          });
        });
        this.formItems = res.editableArea;
        console.log('获取数据表单数据-------------', this.formItems);
      });
    },
    validateStatus(value) {
      if (!value) {
        this.tableValidateStatus = false;
      }
    },
    // // 验证规则
    // generateValidateRule(control) {
    //   const rules = [];
    //   const validateEnclosure = (rule, value, callback) => {
    //     console.log('validateEnclosure', control.fileListData);
    //     let files = this.formData[control.mark];
    //     if (!files || files.length === 0) {
    //       callback(new Error(this.$t('请上传附件')));
    //     } else {
    //       callback();
    //     }
    //   };
    //   if (control.attributeVerification === 'PHONE') {
    //     rules.push({
    //       pattern: /^1[0-9]{10}$/,
    //       message: this.$t('请输入有效的手机号码'),
    //       trigger: 'blur'
    //     });
    //   }

    //   if (control.attributeVerification === 'IDCODE') {
    //     rules.push({
    //       pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,

    //       message: this.$t('请输入有效的身份证号码'),

    //       trigger: 'blur'
    //     });
    //   }
    //   if (control.attributeVerification === 'email') {
    //     rules.push({
    //       message: this.$t('请输入有效的邮箱地址'),
    //       validator: this.validateEmail,
    //       trigger: 'blur'
    //     });
    //   }
    //   if (control.attributeVerification === 'NUMBER') {
    //     rules.push({
    //       pattern: /^\d+(\.\d+)?$/,
    //       message: this.$t('请输入数字'),
    //       trigger: 'blur'
    //     });
    //     // 校验小数点
    //     let decimalPlaces = this.formData[control.mark]?.split('.')[1];
    //     let len = String(decimalPlaces)?.split('').length;
    //     if (len > control.decimalPlaces) {
    //       let msg = this.$t('最多只能输入带有0位小数的数值').replace('0', control.decimalPlaces);
    //       rules.push({
    //         min: parseInt(0),
    //         max: parseInt(control.decimalPlaces),
    //         message: msg,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   const validateEmptySingleRequired = (rule, value, callback) => {
    //     let controlValue = this.formData[control.mark];
    //     let status = true;
    //     control.controlValue.forEach((item, index) => {
    //       if (!item.emptyValue && item.isWrite && controlValue && item.name === controlValue) {
    //         status = false;
    //       }
    //     });
    //     if (!status) {
    //       callback(new Error(`${this.$t('请选择')}${control.controlName}`));
    //     } else {
    //       callback();
    //     }
    //   };
    //   const validateEmptyMultiplyRequired = (rule, value, callback) => {
    //     let controlValue = this.formData[control.mark];
    //     let status = true;
    //     control.controlValue.forEach((item, index) => {
    //       if (!item.emptyValue && item.isWrite && controlValue && controlValue.indexOf(item.name) !== -1) {
    //         status = false;
    //       }
    //     });
    //     if (!status) {
    //       callback(new Error(`${this.$t('请选择')}${control.controlName}`));
    //     } else {
    //       callback();
    //     }
    //   };
    //   if (control.partsType === 'singleChoice') {
    //     rules.push({
    //       validator: validateEmptySingleRequired,
    //       trigger: 'change'
    //     });
    //   } else if (control.partsType === 'multipleChoice') {
    //     rules.push({
    //       validator: validateEmptyMultiplyRequired,
    //       trigger: 'change'
    //     });
    //   }

    //   // 是否必填校验
    //   if (control.isRequired) {
    //     if (
    //       control.partsType === 'singleChoice' ||
    //       control.partsType === 'multipleChoice' ||
    //       control.partsType === 'date'
    //     ) {
    //       rules.push({
    //         required: true,
    //         message: this.$t(`请选择`) + control.controlName,
    //         trigger: 'blur'
    //       });
    //     } else if (control.partsType === 'enclosure') {
    //       rules.push({
    //         required: true,
    //         validator: validateEnclosure,
    //         trigger: 'blur'
    //       });
    //     } else {
    //       rules.push({
    //         required: true,
    //         message: this.$t('请输入') + control.controlName,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   const validateMultipleChoice = (rule, value, callback) => {
    //     const [min, max] = control.numberLimit.split(',');
    //     let multipleValue = this.formData[control.mark];
    //     if (multipleValue && multipleValue.length > parseInt(max)) {
    //       let msg = this.$t('最多只能选择0个').replace('0', max);
    //       callback(new Error(this.$t(`${msg}${control.controlName}`)));
    //     } else if (multipleValue && multipleValue.length < parseInt(min)) {
    //       let msg = this.$t('最少也要选择0个').replace('0', min);
    //       callback(new Error(this.$t(`${msg}${control.controlName}`)));
    //     } else {
    //       callback();
    //     }
    //   };

    //   if (control.numberLimit) {
    //     // console.log('-----limit------', control.value.length);
    //     const [min, max] = control.numberLimit.split(',');
    //     if (control.partsType === 'multipleChoice') {
    //       rules.push({
    //         validator: validateMultipleChoice,
    //         trigger: 'blur'
    //       });
    //     } else if (control.partsType === 'date') {
    //       return;
    //     } else {
    //       let msg = this.$t('长度在0到1个字符')
    //         .replace('0', min)
    //         .replace('1', max);
    //       rules.push({
    //         min: parseInt(min),
    //         max: parseInt(max),
    //         message: msg,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   return rules;
    // },
    // validateEmail(rules, value, callback) {
    //   if (value && !checkEmail(value)) {
    //     callback(new Error(this.$t('邮箱格式有误，请重新填写')));
    //   }
    //   callback();
    // },
    validateTable() {
      //验证表格数据
      this.formItems && Array.isArray(this.formItems) && this.formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`table${item.mark}`][0].validateForm();
              }
            });
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].validateForm();
          }
        });
      });
      let validateStatus = true;
      let length = this.formItems && Array.isArray(this.formItems) ? this.formItems.length : 0;
      for (let i = 0; i < length; i++) {
        let nodeItem = this.formItems[i];
        for (let j = 0; j < nodeItem.form.length; j++) {
          let controlItem = nodeItem.form[j];
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            for (let k = 0; k < controlItem.control.length; k++) {
              let item = controlItem.control[k];
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                if (!this.$refs[`table${item.mark}`][0].validateStatus) {
                  validateStatus = false;
                }
                if (!validateStatus) {
                  break;
                }
              }
            }
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            if (!this.$refs[`table${controlItem.control.mark}`][0].validateStatus) {
              validateStatus = false;
            }
          }
          if (!validateStatus) {
            break;
          }
        }
        if (!validateStatus) {
          break;
        }
      }
      return validateStatus;
    },
    handleDropDownData(value, item) {
      //下拉选择的value格式处理
      if (!value) {
        return {
          textValue: [],
          codeValue: []
        };
      }
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          if (Array.isArray(valueArr) && valueArr.length > 0) {
            //多选
            valueArr.forEach((value, index) => {
              if (index === valueArr.length - 1) {
                text = text + mapObj[value];
              } else {
                text = text + mapObj[value] + '/';
              }
            });
          } else {
            //单选
            text = mapObj[valueArr];
          }
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      let dataType = item.type.type;
      if (dataType === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (dataType === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (dataType === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (dataType === 'country') {
        textData = generaterText(this.countriesDataMap);
      } else if (dataType === 'bank') {
        console.log(this.bankDataObj, 'this.bankDataObj');
        textData = generaterText(this.bankDataObj);
      } else if (dataType === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (dataType === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.id] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList, {});
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    },
    // handleControlValue(controlItem) {
    //   //处理控件的value值
    //   if (controlItem.partsType === 'table') {
    //     // controlItem.value = this.$refs[`table${controlItem.mark}`][0].formDataArray;
    //   } else if (controlItem.partsType === 'dropDown') {
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = this.handleDropDownData(value, controlItem);
    //     delete controlItem.dataList;
    //   } else if (controlItem.partsType === 'date') {
    //     //日期组件处理格式
    //     console.log(controlItem, 'controlItem');
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
    //   } else {
    //     console.log(controlItem, this.formData[controlItem.mark], 'controlItem');
    //     controlItem.value = this.formData[controlItem.mark] || '';
    //   }
    //   controlItem.mark = controlItem.mark.replace('d_', 'd.');
    // },
    generateTableData() {
      this.formItems && Array.isArray(this.formItems) && this.formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          var _controlItem$control;
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[controlItem.mark]) {
                this.$refs[`table${item.mark}`][0].generationData2();
              }
            });
          } else if (((_controlItem$control = controlItem.control) === null || _controlItem$control === void 0 ? void 0 : _controlItem$control.partsType) === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].generationData2();
          }
        });
      });
    },
    // 操作按钮cli
    onSubmit(buttonItem) {
      // console.log('表单数据------------最新----------', this.formData);
      //先校验数据
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        return;
      }
      this.formatDropResourceMap();
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 表单验证通过，可以提交数据
          //table组件生成提交数据
          this.generateTableData();
          const formItems = JSON.parse(JSON.stringify(this.formItems));
          console.log(buttonItem, '表单验证通过', formItems);
          formItems && Array.isArray(formItems) && formItems.forEach(nodeItem => {
            nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control.forEach(item => {
                  this.handleControlValue(item);
                });
              } else {
                this.handleControlValue(controlItem.control);
              }
            });
          });
          if (buttonItem.goBack === 'PREVIEW_FILE') {
            //附件按钮
            // this.$set(buttonItem, 'fileTemplate', buttonItem.url);
            // this.$set(buttonItem, 'url', undefined);

            // console.log(buttonItem, '------buttonItem-----------');
            let params = {
              auditFlowId: this.$route.params.id,
              actionButton: buttonItem,
              editableArea: JSON.stringify(formItems)
            };
            this.showPreviewFile = true;
            this.requestSave(params, 'PREVIEW_FILE');
          } else {
            //如果按钮有发送邮件的功能 打开发送邮件的弹窗
            if (buttonItem.notify.length > 0) {
              this.notifyData = buttonItem;
              this.$nextTick(() => {
                this.showSendEmail = true;
              });
            } else {
              let params = {
                auditFlowId: this.$route.params.id,
                actionButton: buttonItem,
                editableArea: JSON.stringify(formItems)
              };
              this.requestSave(params);
              // console.log(params, 'params');
            }
          }
        } else {
          this.$message.error(this.$t('请填写完整'));
        }
      });
    },
    // 提交接口
    requestSave(params, type) {
      this.loading = true;
      questionnaireSave(params).then(res => {
        this.loading = false;
        if (type === 'PREVIEW_FILE') {
          var _res$previewFiles;
          // console.log(params, '--------params-------');
          this.previewFileList = [];
          // if (res.previewFiles.length > 0) this.showPreviewFile = true;
          (_res$previewFiles = res.previewFiles) === null || _res$previewFiles === void 0 || _res$previewFiles.forEach((item, index) => {
            this.previewFileList.push({
              name: item.fileName,
              url: item.filePath,
              uid: index + 1,
              status: 'done'
            });
          });
          // console.log(this.previewFileList, '-------list----------');
        } else {
          this.$router.push('/questionnaire/customerManage/questionnaireList');
          this.$message.success(this.$t('提交成功'));
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    restPreviewFile() {
      this.previewFileList = [];
      this.showPreviewFile = false;
    },
    formatDropResourceMap() {
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.id] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      this.countriesDataMap = loop(this.countriesData, {});
      this.provinceFirstLevelObj = loop(this.provinceFirstLevel, {});
      this.provinceDataObj = loop(this.provinceData, {});
      this.provinceAreaObj = loop(this.provinceArea, {});
      this.logisticsDataObj = loop(this.logisticsData, {});
      this.bankDataObj = loop(this.bankData, {});
    },
    closeModel(notifyData) {
      this.showSendEmail = false;
      const formItems = JSON.parse(JSON.stringify(this.formItems));
      formItems && Array.isArray(formItems) && formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              this.handleControlValue(item);
            });
          } else {
            this.handleControlValue(controlItem.control);
          }
        });
      });
      let params = {
        auditFlowId: this.$route.params.id,
        actionButton: notifyData,
        editableArea: JSON.stringify(formItems)
      };
      this.requestSave(params);
    },
    // getOptions() {
    //   let resource = [
    //     countriesDATA({}),
    //     planArea({level: 1, type: 'noAll'}),
    //     planArea({level: 2, type: 'noAll'}),
    //     planArea({level: 3, type: 'noAll'}),
    //     bankData({level: 1}),
    //     logisticsData({level: 1})
    //   ];
    //   const loop = (data, obj) => {
    //     data.forEach(item => {
    //       obj[item.id] = item.name;
    //       if (item.children) {
    //         loop(item.children, obj);
    //       }
    //     });
    //     return obj;
    //   };
    //   const loop2 = data => {
    //     data.forEach(item => {
    //       item.id = item.code;
    //       if (item.children) {
    //         loop2(item.children);
    //       }
    //       return item;
    //     });
    //   };
    //   Promise.all(resource).then(res => {
    //     this.countriesData = res[0] || [];
    //     this.countriesDataMap = loop(res[0], {});
    //     loop2(res[1]);
    //     loop2(res[2]);
    //     loop2(res[3]);
    //     this.provinceFirstLevel = res[1] || [];
    //     this.provinceFirstLevelObj = loop(res[1], {});
    //     this.provinceData = res[2] || [];
    //     this.provinceDataObj = loop(res[2], {});
    //     this.provinceArea = res[3] || [];
    //     this.provinceAreaObj = loop(res[3], {});
    //     this.bankData = res[4] || [];
    //     this.bankDataObj = loop(res[4], {});
    //     console.log(this.bankDataObj, 'this.bankDataObj');
    //     this.logisticsData = res[5] || [];
    //     this.logisticsDataObj = loop(res[5], {});
    //   });
    // },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    }
  }
};